import cx from 'classnames';
import type { FunctionComponent, ReactNode } from 'react';

import styles from './TreeViewLayout.module.less';

type Props = {
  header: ReactNode | string;
  children: ReactNode;
  className?: string;
};

/**
 * TreeView component for the TreeViewLayout.
 * Renders a container with an optional header and scrollable content area.
 */
export const TreeViewLayoutTreeView: FunctionComponent<Props> = ({ header, children, className }) => (
  <div className={cx(styles.treeView, className)}>
    <div className={styles.treeViewHeader}>
      {header}
    </div>
    <div className={styles.treeViewContent}>
      {children}
    </div>
  </div>
);
